import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import React, { ChangeEvent, useState, type JSX } from 'react';
import { FOTOKATEGORIEN } from '../../shared/domain/vorgang';
import { SPACING_BETWEEN_FORM_FIELDS } from '../common/spacings';
import { dialogActions } from './Dialog';

type Props = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onEdit: (kategorien: string[]) => void;
  readonly fotoKategorien: string[];
  readonly text: string;
  readonly titel: string;
  readonly saveButtonText: string;
};

export function FotoKategorienEditierenDialog({ open, onClose, onEdit, fotoKategorien, text, titel, saveButtonText }: Props): JSX.Element {
  const [kategorien, setKategorien] = useState<{ label: string; value: boolean }[]>(
    FOTOKATEGORIEN.map((k) => ({ label: k, value: fotoKategorien.includes(k) }))
  );

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="kategorieHinzufuegen">
      <DialogTitle id="kategorieHinzufuegen">{titel}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
        <Grid container spacing={SPACING_BETWEEN_FORM_FIELDS}>
          {kategorien.map((kategorie) => (
            <Grid size={6} key={kategorie.label}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={kategorie.value}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      setKategorien((prev) => prev.map((k) => (k.label === kategorie.label ? { label: k.label, value: event.target.checked } : k)));
                    }}
                    name={kategorie.label}
                    color="primary"
                    data-testid="abtretungserklaerungCheckbox"
                  />
                }
                label={kategorie.label}
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions sx={dialogActions}>
        <Button autoFocus onClick={onClose} variant="contained" color="secondary">
          Abbrechen
        </Button>
        <Button onClick={() => onEdit(kategorien.filter((k) => k.value).map((k) => k.label))} variant="contained" color="primary">
          {saveButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
